import React from "react";
import sample from "../assets/sampleimage.png"; 

const Shipping = () => {
  return (
    <div>

      
      <div className="mb-4">
        <img
          src={sample}
          alt="Shipping Policy Banner"
          className="img-fluid w-100"
        />
      </div>

    
      <div className="container mb-4">
        <h2 className="text-center mb-4">Shipping Policy</h2>

        <div className="card shadow-sm p-4">

          <p className="mb-4">
            Our boutique ensures safe and timely delivery of all orders placed on  
            our website. Once an order is confirmed, it is processed and  
            dispatched through trusted courier partners across India. Delivery  
            timelines may vary depending on the customer’s location, order  
            volume, and courier service availability.
          </p>

          <p className="mb-4">
            Most orders are dispatched within <strong>1–3 business days</strong>.  
            After dispatch, deliveries typically reach the customer within  
            <strong>5–7 working days</strong>. Rural or remote locations may take  
            additional time due to courier limitations. Customers will receive an  
            email or SMS with tracking details once the order is shipped.
          </p>

          <p className="mb-4">
            It is the customer’s responsibility to provide accurate shipping  
            information at the time of placing the order. Incorrect address,  
            unavailability of the customer, or refusal to accept the parcel may  
            lead to delays or cancellations. In such cases, shipping charges (if  
            applicable) are non-refundable.
          </p>

          <p className="mb-4">
            In the event of unavoidable delays caused by courier partners,  
            natural events, or operational challenges, our boutique will not be  
            held responsible. However, we will fully assist the customer in  
            tracking their shipment and resolving any delivery-related concerns  
            at the earliest possible time.
          </p>

          <p>
            By placing an order with us, you agree to the terms of this Shipping  
            Policy. We may update or revise this policy from time to time.  
            Customers are encouraged to review this page periodically to stay  
            informed about changes.
          </p>

        </div>
      </div>
    </div>
  );
};

export default Shipping;
